/**
 * AttributeBar - Single attribute progress bar for RPG-style model stats.
 * SPD/AGI/INT/PWR: score is 1-100, used directly as bar width.
 * ATK/DEF: score is raw cost ($/M) or null (unknown), bar uses log-scale normalization.
 */

import {
  ATTRIBUTE_FIXED_COLORS,
  ATTRIBUTE_FIXED_BAR_COLORS,
  getAttributeDisplay,
} from '@/constants/llm/modelAttributes';

export function AttributeBar({ abbrev, score }: { abbrev: string; score: number | null }) {
  const textColor = ATTRIBUTE_FIXED_COLORS[abbrev] || 'text-white/50';
  const barColor = ATTRIBUTE_FIXED_BAR_COLORS[abbrev] || 'bg-white/30';
  const { barPercent, label } = getAttributeDisplay(abbrev, score);
  return (
    <div className="flex items-center gap-2">
      <span className={`w-8 text-[10px] font-medium ${textColor}`}>{abbrev}</span>
      <div className="flex-1 h-2 bg-white/10 rounded-full overflow-hidden">
        <div className={`h-full ${barColor} transition-all`} style={{ width: `${barPercent}%` }} />
      </div>
      <span className={`min-w-[24px] text-[10px] font-bold ${textColor} text-right`}>{label}</span>
    </div>
  );
}

export default AttributeBar;
